module.exports = __webpack_public_path__ + "07c8d4529e91ab3083e10509b6f12a0e.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarArabella1.png
// module id = 139
// module chunks = 0